import * as React from 'react';
import { sprykerPlaceholderImage, sprykerProductImageSrcSet } from '../../../react/common/lib';
import { IProductItemImages } from '../../interfaces';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import Utils from 'PyzShopUi/scripts/utils/utils';

interface IProductItemCompactProps {
    name: string;
    url: string;
    images: IProductItemImages;
    sku: string;
    isKeyboardAccessible?: boolean;
    isInViewport?: boolean;
}

const ProductItemCompact: React.FunctionComponent<IProductItemCompactProps> = ({ sku, name, isKeyboardAccessible, isInViewport, ...props }) => {
    const imgId = `product-compact-image-cover-${sku}-${Utils.getRandomId()}`;
    const { translate } = useTranslationHook();
    const imgAlt = name?.length < 10 ? `${translate('product', { ns: 'url' })} ${name}` : name;

    return (
        <div className='product-item product-item-compact'>
            <div className='product-image-cover lazy-image-container'>
                <a itemProp='url' className='product-image-cover__full-link' href={props.url} {...(isInViewport ? { "aria-labelledby": imgId } : { 'aria-label': imgAlt })} tabIndex={isKeyboardAccessible ? 0 : -1} aria-hidden={isKeyboardAccessible ? "false" : "true"} />
                <img
                    id={imgId}
                    alt={imgAlt}
                    src={sprykerPlaceholderImage()}
                    className='product-image lazyload'
                    data-src={props.images.externalUrlThumbnail}
                    data-srcset={sprykerProductImageSrcSet(props.images)}
                />
            </div>
        </div>
    );
}

export default ProductItemCompact;
